import { TopicEntity } from '@/graphql/generated/graphql';
import Container from '@/components/Container';
import { useKnowledgeHubStore } from './store/useKnowledgeHubStore';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '@/components/Button';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { compare } from './utils/compare.utils';

export default function ChoseThemeFilter({ topic }: { topic: TopicEntity }) {
  const { t, filterByTheme } = useKnowledgeHubStore();
  const { topic: topicParam, theme: themeParam } = useParams();
  const navigate = useNavigate();

  return (
    <AnimatedFadeInComponent>
      <Container>
        <div className="col-span-12 flex flex-wrap items-center justify-center gap-5 lg:col-start-11 lg:col-end-3">
          {topic?.attributes?.themes?.data.map((theme) => {
            const active = compare(themeParam, theme?.attributes?.theme?.toString());
            return (
              <>
                <Button
                  onClick={(e) => {
                    e?.preventDefault();
                    e?.stopPropagation();

                    if (active) {
                      filterByTheme('null', topic);
                      navigate(`/knowledge-hub/topic/${topicParam}`);
                    } else {
                      navigate(`/knowledge-hub/topic/${topicParam}/theme/${theme?.attributes?.theme?.toString()}`);
                    }
                  }}
                  theme={active ? 'solid' : 'outline'}
                  as="a"
                  href={`/knowledge-hub/topic/${topicParam}/theme/${theme?.attributes?.theme?.toString()}`}
                  className="!border-1 !rounded-[16px] !border !py-[5px] text-sh-12-18 !font-normal">
                  {t(theme?.attributes?.theme?.toString() || '')}
                </Button>
              </>
            );
          })}
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
